export const STEP_TYPE_FULFILLED = 'STEP_TYPE_FULFILLED';
export const STEP_SHIPMENT_FULFILLED = 'STEP_SHIPMENT_FULFILLED';
export const STEP_OPTIONAL_SERVICES_FULFILLED = 'STEP_OPTIONAL_SERVICES_FULFILLED';
export const STEP_SHIPMENT_SENDER_SSN_ADDED = 'STEP_SHIPMENT_SENDER_SSN_ADDED';
export const STEP_INFO_FULFILLED = 'STEP_INFO_FULFILLED';
export const STEP_EXPORT_FULFILLED = 'STEP_EXPORT_FULFILLED';
export const STEP_FEEDBACK_FULFILLED = 'STEP_FEEDBACK_FULFILLED';
export const SUBMIT_DOMESTIC_SHIPMENT_PENDING = 'SUBMIT_DOMESTIC_SHIPMENT_PENDING';
export const SUBMIT_DOMESTIC_SHIPMENT_FULFILLED = 'SUBMIT_DOMESTIC_SHIPMENT_FULFILLED';
export const SUBMIT_DOMESTIC_SHIPMENT_FAILED = 'SUBMIT_DOMESTIC_SHIPMENT_FAILED';
export const SUBMIT_INTERNATIONAL_SHIPMENT_PENDING = 'SUBMIT_INTERNATIONAL_SHIPMENT_PENDING';
export const SUBMIT_INTERNATIONAL_SHIPMENT_FULFILLED = 'SUBMIT_INTERNATIONAL_SHIPMENT_FULFILLED';
export const SUBMIT_INTERNATIONAL_SHIPMENT_FAILED = 'SUBMIT_INTERNATIONAL_SHIPMENT_FAILED';
export const SET_INSURANCE_OPTIONAL_SERVICE_PRICE_FULFILLED = 'SET_INSURANCE_OPTIONAL_SERVICE_PRICE_FULFILLED';
export const SET_COD_OPTIONAL_SERVICE_PRICE_FULFILLED = 'SET_COD_OPTIONAL_SERVICE_PRICE_FULFILLED';
export const STEP_TYPE_COUNTRY_ADDED = 'STEP_TYPE_COUNTRY_ADDED';
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';
export const RESET_TO_INITIAL_VALUES = 'RESET_TO_INITIAL_VALUE';
export const RESET_SUBMISSION_FAILURE = 'RESET_SUBMISSION_FAILURE';
export const REGISTER_SHIPMENT_SET_INITIALVALUES = 'REGISTER_SHIPMENT_SET_INITIALVALUES';
